import React from 'react';

/**
 * Minimal class-based error boundary so admin pages "fail safely" rather
 * than rendering a blank page when a downstream component throws.
 *
 * Usage:
 *   <AdminErrorBoundary pageName="Audit Trail">
 *     ...children...
 *   </AdminErrorBoundary>
 */
class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || 'Unknown error' };
  }

  componentDidCatch(error, info) {
     
    console.error('[AdminErrorBoundary]', this.props.pageName || 'page', error, info);
  }

  reset = () => this.setState({ hasError: false, message: '' });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        className="bg-white border border-red-200 rounded-2xl p-6 text-center"
        data-testid="admin-error-boundary"
      >
        <p className="text-sm font-bold text-red-700 mb-1">
          {this.props.pageName || 'This page'} hit an unexpected error.
        </p>
        <p className="text-xs text-gray-600 mb-4 font-mono">{this.state.message}</p>
        <button
          onClick={this.reset}
          className="px-4 py-2 text-xs font-semibold rounded-lg bg-gray-900 text-white hover:bg-black transition-colors"
          data-testid="admin-error-retry"
        >
          Try again
        </button>
      </div>
    );
  }
}

export default AdminErrorBoundary;
